var exports = {
  "kL": "xe533113f--b336b0--container",
  "iE": "xe533113f--b336b0--wrapper",
  "Kk": "xe533113f--b336b0--icon",
  "y_": "xe533113f--b336b0--remoteness",
};

module.exports = exports;
